import style from "styled-components";

const MarginWrapper = style.div`
    margin-left: 95px;
    margin-right: 95px;
    @media (max-width: 737px) {
        margin-left: 16px;
        margin-right: 16px;
    }
`;

export default MarginWrapper;



// WEBPACK FOOTER //
// ./components/misc/MarginWrapper.jsx